import { InteractiveModuleModel, InteractiveModuleEnrolmentModel } from './';

export class InteractiveModuleFutureProjectionModel {
    InteractiveModule: InteractiveModuleModel;
    Enrolments: InteractiveModuleEnrolmentModel[];
    TotalEnrolments: number;
}